import dayjs from 'dayjs';

export const isSameDate = (date1: DateLike, date2?: DateLike) =>
  dayjs(date1).format('YYYYMMDD') === dayjs(date2).format('YYYYMMDD');

export const toStringOrStringArray = <
  T extends DateLike | DateLike[],
  R extends T extends Array<DateLike> ? string[] : string,
>(
  value: T,
): R =>
  (!Array.isArray(value)
    ? dayjs(value).format('YYYY-MM-DD')
    : value.map(v => dayjs(v).format('YYYY-MM-DD'))) as R;

export const toDateOrDateArray = <
  T extends string | string[],
  R extends T extends Array<string> ? Date[] : Date,
>(
  value: T,
): R =>
  (!Array.isArray(value)
    ? dayjs(value).toDate()
    : value.map(v => dayjs(v).toDate())) as R;
